import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            {t("section_categories")}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            {t("section_categories_desc")}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-lg bg-background-100 hover:bg-background-200/70 transition-all duration-300"
            >
              <span className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full mb-3 transition-transform duration-300 group-hover:scale-110 ${
                cat.color === "accent"
                  ? "bg-accent-100 text-accent-600"
                  : "bg-primary-100 text-primary-600"
              }`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 mb-1 whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-400">{cat.count}篇</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}